<template>
  <v-container fluid>
    <v-layout justify-center align-center>
      <v-flex sm10>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="successAction" />
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="main" :urls="urls" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'config.banks-create' }
        ],
        titles: [
          { text: 'Plazo', value: 'plazo', class: 'black--text' },
          { text: 'Capital', value: 'capital', class: 'black--text' },
          { text: 'Seguro Vida', value: 'seguroVida', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber lighten-1', action: 'updateData' }
        ]
      },
      footer: {
        paging: true
      }
    },
    main: {},
    form: [],
    urls: '',
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog
  },
  mounted () {
    this.PostListObjects({ url: '/config/deadlines' })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['PostListObjects']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = false
      this.PostListObjects({ url: '/config/deadlines' })
    },
    newData (item) {
      this.main = {}
      this.form = this.get_DeadlinesForm
      this.urls = '/config/deadlines/store'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 450, title: 'Nuevo Banco' })
    },
    updateData ({ item }) {
      this.main = item
      this.form = this.get_DeadlinesForm
      this.urls = `/config/deadlines/${item.id}`
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 450, title: 'Editar Banco' })
    }
  },
  computed: {
    ...mapGetters(['get_objects', 'get_dialogMain',
      'get_DeadlinesForm'])
  },
  watch: {
    get_objects (val) {
      this.table.header.loading = false
      this.table.body.data = val
    }
  }
}
</script>

<style>

</style>
